import React from 'react';
import { IImageSectionEntry } from '../../../../contentful/types/IImageSectionEntry';
import { ResponsivePicture } from '../../../../ui';
import { Section, SectionHeader } from './Section';

export interface IImageSectionProps {
	section: IImageSectionEntry;
}

export function ImageSection({ section }: IImageSectionProps) {
	return (
		<Section>
			{section.fields.title && (
				<SectionHeader styling="h4">{section.fields.title}</SectionHeader>
			)}
			<ResponsivePicture
				alt={section.fields.image?.fields.description ?? 'image'}
				rounded
				noMaxWidth
				source={section.fields.image?.fields.file.url}
			/>
		</Section>
	);
}
